import { makeStyles } from '@material-ui/styles';

import Colors from 'constants/Colors';

export default makeStyles({
  root: {
    minHeight: '2rem',
    backgroundColor: Colors.WHITE,
  },
});
